// extracted by mini-css-extract-plugin
export default {"header":"Section_header__v6cqh","cardWrapper":"Section_cardWrapper__JiG+w","wrapper":"Section_wrapper__9APsL","toggleText":"Section_toggleText__PBDZf"};